import type { Build } from '@/api/schemas';
import { Card } from '@/components/ui/card';
import { isTerminal } from '../buildHelpers';
import { AwaitingClientPanel } from './AwaitingClientPanel';
import { BuildHeader } from './BuildHeader';
import { BuildStepper } from './BuildStepper';
import { BuildSubmissionsCard } from './BuildSubmissionsCard';
import { BuildSummary } from './BuildSummary';
import { BuildTabs } from './BuildTabs';
import type { BuildTabQueries } from './useBuildTabQueries';

interface Props {
  build: Build;
  slug: string;
  now: number;
  tab: string;
  onTabChange: (tab: string) => void;
  queries: BuildTabQueries;
}

/** Screen 03 for a loaded build: header + stepper, the tabs card, the metadata card and, for an app with a Google Play app, its submissions. */
export function BuildDetail({ build: b, slug, now, tab, onTabChange, queries }: Props) {
  return (
    <div className="flex flex-col gap-5" data-testid="build-detail" data-status={b.status}>
      <BuildHeader build={b} projectSlug={slug} now={now} artifacts={queries.artifacts.data} />
      {b.status === 'awaiting_client' ? <AwaitingClientPanel build={b} now={now} /> : null}
      <BuildStepper build={b} />
      <div className="grid gap-5 lg:grid-cols-[minmax(0,1fr)_380px] lg:items-start">
        <Card className="enter overflow-hidden">
          <BuildTabs tab={tab} onTabChange={onTabChange} queries={queries} now={now} pending={!isTerminal(b.status)} />
        </Card>
        <div className="flex min-w-0 flex-col gap-5">
          <BuildSummary build={b} now={now} events={queries.events.data} />
          <BuildSubmissionsCard build={b} artifacts={queries.artifacts.data} />
        </div>
      </div>
    </div>
  );
}
